module.exports = __webpack_public_path__ + "static/media/kinto-one-star.f8241ff2.svg";